import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';
// import './global_classes.css';
import App from './App';
import '../src/Utils/font.css';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material';
import store from './Store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';

const root = ReactDOM.createRoot(document.getElementById('root'));
const theme = createTheme(
  {
    typography: {
      fontFamily: 'var(--primary-font-family)',
    },
  }
);

root.render(
  <React.Fragment>
    <HashRouter>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <PersistGate persistor={persistStore(store)}>
            <App />
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </HashRouter>
  </React.Fragment>
);

reportWebVitals();
